import React, { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

const AnimatedProgressBar = ({ duration = 2 }) => {
    const controls = useAnimation();
    const loadingBarRef = useRef(null);
    const containerRef = useRef(null);
  
    useEffect(() => {
      const animateLoading = async () => {
        if (!containerRef.current) return;
  
        const containerWidth = containerRef.current.offsetWidth;
        const loadingBarWidth = containerWidth / 4;
        const targetX = containerWidth + loadingBarWidth;
  
        while (true) {
          await controls.start({
            x: targetX,
            transition: { duration: duration, ease: "linear" },
          });
  
          await controls.set({ x: -loadingBarWidth }); // Reset immediately after reaching end
        }
      };
  
      animateLoading();
    }, [controls, duration]);
  
    return (
      <div ref={containerRef} className="relative w-full h-2.5 overflow-hidden">
        <motion.div
          ref={loadingBarRef}
          className="absolute h-full bg-primary-light dark:bg-primary-dark w-1/4 rounded-full"
          animate={controls}
        />
      </div>
    );
  };
  
  export default AnimatedProgressBar;